
import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Home, 
  Calendar, 
  MapPin, 
  Heart, 
  CreditCard, 
  Sparkles,
  Instagram,
  Music,
  Youtube
} from 'lucide-react';

const MobileFooter = () => {
  const quickNavItems = [
    { icon: Home, label: 'Home', href: '/' },
    { icon: Sparkles, label: 'Treatments', href: '/treatments' },
    { icon: CreditCard, label: 'Membership', href: '/membership' },
    { icon: Heart, label: 'Take Quiz', href: '/quiz' },
    { icon: MapPin, label: 'Locations', href: '/locations' },
    { icon: Calendar, label: 'Book Now', href: '/locations#book' }
  ];

  const socialLinks = [
    { icon: Instagram, label: 'Instagram', href: 'https://instagram.com/juv.aesthetics', external: true },
    { icon: Music, label: 'TikTok', href: 'https://tiktok.com/@juvstudio', external: true },
    { icon: Youtube, label: 'YouTube', href: 'https://youtube.com/@juvstudio', external: true }
  ];

  return (
    <footer className="block lg:hidden bg-gradient-to-b from-juv-cream-white to-juv-soft-blush/50 pt-12 pb-20">
      <div className="container mx-auto px-6">
        {/* Section 1: Quick Navigation Grid */}
        <div className="mb-8">
          <div className="grid grid-cols-3 gap-4">
            {quickNavItems.map((item, index) => {
              const IconComponent = item.icon;
              return (
                <Link
                  key={index}
                  to={item.href}
                  className="flex flex-col items-center justify-center p-4 bg-white rounded-2xl shadow-soft hover:shadow-luxury transition-all duration-300 hover:scale-105 group"
                >
                  <IconComponent className="w-6 h-6 text-juv-terracotta mb-2 group-hover:scale-110 transition-transform duration-200" />
                  <span className="text-xs font-medium text-juv-deep-chestnut text-center leading-tight">
                    {item.label}
                  </span>
                </Link>
              );
            })}
          </div>
        </div>

        {/* Section 2: Branded CTA Strip */}
        <div className="mb-8 bg-gradient-to-r from-juv-soft-blush to-juv-rose-clay rounded-2xl p-6 text-center">
          <p className="text-juv-deep-chestnut font-light mb-4 leading-relaxed">
            Not your average medspa. Ready to discover your path to glow?
          </p>
          <div className="flex gap-3">
            <Link
              to="/quiz"
              className="flex-1 bg-white text-juv-terracotta py-3 px-4 rounded-full font-medium text-sm hover:bg-juv-cream-white transition-colors duration-200 text-center"
            >
              Take the Quiz
            </Link>
            <Link
              to="/membership"
              className="flex-1 bg-juv-terracotta text-white py-3 px-4 rounded-full font-medium text-sm hover:bg-juv-deep-chestnut transition-colors duration-200 text-center"
            >
              Become a Member
            </Link>
          </div>
        </div>

        {/* Section 3: Social & Studio Links */}
        <div className="mb-8">
          <h3 className="text-lg font-semibold text-juv-deep-chestnut mb-4 text-center">
            Follow Our Journey
          </h3>
          <div className="flex justify-center gap-6">
            {socialLinks.map((social, index) => {
              const IconComponent = social.icon;
              return (
                <a
                  key={index}
                  href={social.href}
                  target={social.external ? "_blank" : "_self"}
                  rel={social.external ? "noopener noreferrer" : ""}
                  className="flex flex-col items-center p-3 bg-white rounded-xl shadow-soft hover:shadow-luxury transition-all duration-300 hover:scale-105 group"
                >
                  <IconComponent className="w-5 h-5 text-juv-terracotta group-hover:text-juv-deep-chestnut transition-colors duration-200" />
                  <span className="text-xs text-juv-deep-chestnut mt-1">
                    {social.label}
                  </span>
                </a>
              );
            })}
          </div>
          
          {/* Partner Link */}
          <div className="text-center mt-6">
            <Link
              to="/partner"
              className="inline-flex items-center justify-center py-2 px-6 bg-juv-deep-chestnut text-white rounded-full font-medium text-sm hover:bg-juv-terracotta transition-colors duration-200"
            >
              Partner With Us
            </Link>
          </div>
        </div>

        {/* Section 4: Legal & Branding */}
        <div className="border-t border-juv-rose-clay/30 pt-6 text-center">
          <h2 className="text-xl font-serif text-juv-deep-chestnut mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
            JUV Medspa<sup className="text-sm">™</sup>
          </h2>
          <p className="text-sm text-juv-deep-chestnut/70 mb-3">
            © 2025 All rights reserved
          </p>
          <div className="flex justify-center gap-6 text-sm">
            <Link
              to="/terms"
              className="text-juv-deep-chestnut/70 hover:text-juv-terracotta transition-colors duration-200 relative after:content-[''] after:absolute after:w-full after:scale-x-0 after:h-px after:bottom-0 after:left-0 after:bg-juv-soft-blush after:origin-bottom-right after:transition-transform after:duration-300 hover:after:scale-x-100 hover:after:origin-bottom-left"
            >
              Terms
            </Link>
            <Link
              to="/privacy"
              className="text-juv-deep-chestnut/70 hover:text-juv-terracotta transition-colors duration-200 relative after:content-[''] after:absolute after:w-full after:scale-x-0 after:h-px after:bottom-0 after:left-0 after:bg-juv-soft-blush after:origin-bottom-right after:transition-transform after:duration-300 hover:after:scale-x-100 hover:after:origin-bottom-left"
            >
              Privacy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default MobileFooter;
